import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-8 md:py-10">
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center gap-4 overflow-x-auto scrollbar-hide" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
          <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
            热门分类：
          </span>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="whitespace-nowrap inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-background-200 text-foreground-700 hover:text-foreground-950 text-sm font-medium cursor-pointer transition-colors duration-200"
            >
              <i className={`${cat.icon} text-base w-4 h-4 flex items-center justify-center`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}